import { ICON_AGENCIES, ICON_CALENDAR } from "common/constants";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import * as moment from "moment";

const LTAItem = ({
  data,
  index,
}: {
  data: any;

  index?: number;
}) => {
  const details = [
    data?.ltaNumber &&
      `<span class="fw-medium">LTA Number:</span> ${data.ltaNumber}`,
    data?.startDate &&
      `<span class="fw-medium">Start Date:</span> ${moment(
        new Date(data.startDate)
      ).format("dddd, MMM DD, Y")}`,
    data?.endDate &&
      `<span class="fw-medium">End Date:</span> ${moment(
        new Date(data.endDate)
      ).format("dddd, MMM DD, Y")}`,
    data?.contractor &&
      `<span class="fw-medium">Contractor:</span> ${data.contractor}`,
    data?.leadAgency &&
      `<span class="fw-medium">Lead Agency:</span> ${data.leadAgency}`,
    data?.location && `<span class="fw-medium">Region:</span> ${data.location}`,
  ].filter(Boolean);

  const detailsString = useMemo(() => details.join(", "), [details]);

  // Create a unique ID for this component instance to scope the styles
  const componentId = React.useMemo(
    () =>
      `lta-item-${data?.id || Math.random().toString(36).substring(2, 9)}`,
    [data?.id]
  );

  return (
    <div className={index === 0 ? "pb-3" : "py-3"} id={componentId}>
      {/* Add scoped styles for highlighting em tags */}
      <style>
        {`
          #${componentId} em {
            background-color: #fff59d;
            font-style: normal;
            padding: 0 0px;
            border-radius: 2px;
            font-weight: 500;
          }
        `}
      </style>
      <h5 className="mb-1">
        <Link to={`/ltas/${data.id}`}>
          <span dangerouslySetInnerHTML={{ __html: data?.title || "" }}></span>
        </Link>
      </h5>
      <p className="text-success mb-2">LTAs</p>
      <p
        className="text-muted mb-2"
        dangerouslySetInnerHTML={{ __html: `... ${detailsString} ...` }}
      ></p>

      <ul className="list-inline d-flex align-items-center g-3 text-muted fs-14 mb-0">
        <li className="list-inline-item me-3">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_CALENDAR}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">
                {moment(new Date(data?.updatedAt)).format("DD MMM Y")}
              </span>
            </div>
          </div>
        </li>
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_AGENCIES}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">{data?.leadAgency}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default LTAItem;
